export const ALLOW_URLS = [/airbaltic\.com/]

export const IGNORE_ERRORS = [
  'top.GLOBALS',
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  'fb_xd_fragment',
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  'conduitPage',
  'Script error.',
  '_avast_submit',
  'Error: Request failed with status code 403',
  'doLogout',
  'failedLogout',
  'sharedStorage is disabled'
]

export const DENY_URLS = [
  /pagead\/js/i,
  /graph\.facebook\.com/i,
  /connect\.facebook\.net\/en_US\/all\.js/i,
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  /extensions\//i,
  /^chrome:\/\//i,
  /127\.0\.0\.1:4001\/isrunning/i,
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  /^chrome-extension:\/\//i
]

export const EXCLUDE_LIST = ["Can't find variable: _AutofillCallbackHandler"]
